import React from 'react';
import background from '../../assets/seagrass.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoSeagrass extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Seagrass"
        paragraph="The root systems of seagrass beds secure soft sediments, preventing it from being washed onto coral reefs, and providing some protection to coasts and coastal communities from strong ocean storms."
        background={background}
     />
  
  );
 }
}   

export default InfoSeagrass;